/* eslint-disable camelcase */
export default {
  title: "Реферальная ссылка",
  copied_to_clipboard: 'Ваша реферальная ссылка скопирована в буфер обмена',
};
